module.exports = __webpack_public_path__ + "static/img/stim-img.3c541c82.png";